<template>
    <section :id="'grp' + id" class="field" :role="ariaRole">
        <div :id="errorElementIdComputed" class="ui error message" ></div>
        <div :class="'ui ' + msg.type + ' message'" v-for="(msg) in messages" :key="msg.text">
            <i class="close icon" v-on:click="close"></i>
            {{msg.text}}
            <div class="header" v-if="msg.header">{{ msg.header }}</div>
            <ul class="list" v-for="(text) in msg.texts" :key="text">
                <li>{{ text }}</li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
  props: {
    id: String,
    errorElementId: String,
    ariaRole: {
      type: String,
      default: 'alert'
    }
  },
  computed: {
    errorElementIdComputed () {
      return this.errorElementId ? this.errorElementId : 'validation' + this.id
    }
  },
  data: function () {
    return {
      messages: []
    }
  },
  methods: {
    clear: function () {
      jQuery('#' + this.errorElementIdComputed).empty()
      this.messages = []
    },
    showMessage: function (type, text) {
      this.messages.push({
        type: type,
        text: text
      })
    },
    showMessageList: function (type, header, texts) {
      this.messages.push({
        type: type,
        header: header,
        texts: texts
      })
    },
    close: function (e) {
      $(e.target).closest('.message').transition('fade')
    }
  },
  mounted: function () {
    console.debug(`Initialized notification display [messages=${this.messages}]`)
  }
}
</script>

<style>
    .ui.message {
        padding: 16px;
    }

    .ui.message .list:not(.ui) li {
        font-weight: bold;
        margin-left: 0;
    }

    .ui.message .list:not(.ui) li:before {
        display: none;
    }

    .ciam-error-tracking-id {
        font-weight: normal;
        font-size: .8em;
        line-height: .8em;
    }
</style>
